import {
    activateTwoStepAuthentication,
    deactivateTwoStepAuthentication,
    fetchTwoStepAuthenticationActivationStatus,
} from './twoStepAuthentication.actions';
import { createSlice } from '@reduxjs/toolkit';
import { defaultTwoStepAuthenticationSlice } from './twoStepAuthentication.types';

const twoStepAuthenticationSlice = createSlice({
    extraReducers: (builder) => {
        builder.addCase(fetchTwoStepAuthenticationActivationStatus.pending, (slice) => {
            slice.loading = true;
        });
        builder.addCase(fetchTwoStepAuthenticationActivationStatus.fulfilled, (slice, { payload }) => {
            slice.activated = payload;
            slice.loading = false;
        });
        builder.addCase(fetchTwoStepAuthenticationActivationStatus.rejected, (slice) => {
            slice.activated = undefined;
            slice.loading = false;
        });

        builder.addCase(activateTwoStepAuthentication.pending, (slice) => {
            slice.loading = true;
        });
        builder.addCase(activateTwoStepAuthentication.fulfilled, (slice, { payload }) => {
            slice.activated = payload;
            slice.loading = false;
        });

        builder.addCase(deactivateTwoStepAuthentication.pending, (slice) => {
            slice.loading = true;
        });
        builder.addCase(deactivateTwoStepAuthentication.fulfilled, (slice, { payload }) => {
            slice.activated = payload;
            slice.loading = false;
        });
    },
    initialState: defaultTwoStepAuthenticationSlice,
    name: 'twoStepAuthentication',
    reducers: {},
});

export const { reducer: twoStepAuthenticationReducer } = twoStepAuthenticationSlice;
